// extracted by mini-css-extract-plugin
export var carrierIcon = "_xh-0";
export var carrierLogo = "_xh-1";
export var detailsSection = "_xh-2";